import React from 'react'

export default function Consult() {
  return (
    <div>Consult</div>
  )
}
